import queryString from 'query-string';
import * as env from '../../../../utils/env';
import { campaignId, getCampaignType } from '../../utils/campaign';
import request from './request';

export const updatePassword = (passwords: Record<string, string>) => {
  return request(
    `${env.userEndpoint}/users/self/password`,
    'PATCH',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(passwords),
  );
};

export const updateShippingInfo = (ShippingInfo: Record<string, string>) => {
  return request(
    `${env.userEndpoint}/users/self/shipping`,
    'PATCH',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(ShippingInfo),
  );
};

export const getIsAccountPastDue = () => request(`${env.aceApi}api/1/accounts/past-due`);

export const updateProducts = (
  campaignIdNumber: string,
  productsToUpdate: Record<string, string>,
) => {
  const requestUrl = `${env.aceApi}api/1/campaigns/${campaignIdNumber}/product-bundles`;
  const data = JSON.stringify(productsToUpdate);
  return request(requestUrl, 'PUT', { 'Content-Type': 'application/json' }, data);
};

export const updateProfileInfo = (profileInfo: Record<string, string>) => {
  const requestUrl = `${env.aceApi}api/1/accounts/profiles`;
  const data = JSON.stringify(profileInfo);
  return request(requestUrl, 'PUT', { 'Content-type': 'application/json' }, data);
};

/**
 *
 */
export function getAccount() {
  const requestUrl = `${env.aceApi}api/1/accounts`;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v2+json',
  };
  return request(requestUrl, 'GET', headers);
}

export const getUserNextRenewal = () => {
  const requestUrl = `${env.myAccountApi}/api/1/accounts/next-renewal`;
  return request(requestUrl);
};

export const getInvoicesByUserId = (userId, limit, offset) => {
  const queryParams = {};
  if (limit) {
    queryParams.limit = limit;
    queryParams.offset = offset;
  }
  const requestUrl = `${env.aceApi}api/1/invoices/users/${userId}`;
  const endpoint = limit
    ? `${requestUrl}?${queryString.stringify(queryParams, {
        arrayFormat: 'comma',
      })}`
    : requestUrl;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v2+json',
  };
  return request(endpoint, 'GET', headers);
};

export const getAllInvoicesByUserId = (userId) => {
  const requestUrl = `${env.myAccountApi}/api/1/invoices/users/${userId}`;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v1+json',
  };

  return request(requestUrl, 'GET', headers);
};

export const getInvoiceLineItemsByUuid = (uuid) => {
  const requestUrl = `${env.myAccountApi}/api/1/invoices/uuid/${uuid}`;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v1+json',
  };

  return request(requestUrl, 'GET', headers);
};

export const getUserCredits = () => request(`${env.aceApi}api/1/credits/users`);

export const getRemainingBoxes = () => request(`${env.myAccountApi}/api/1/box/remaining-boxes`);

/**
 *
 */
export function getCredit() {
  let requestUrl = `${env.aceApi}api/1/credits?type=${getCampaignType()}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export const getUserAvatar = () => request(`${env.avatarApi}/self/avatar`);

export const setUserAvatar = (formData) => {
  return request(
    `${env.avatarApi}/self/avatar`,
    'PUT',
    {
      'FFF-Auth': 'V1.1',
    },
    formData,
  );
};

export const clearUserCache = () => {
  const endpoint = `${env.aceApi}api/1/caches/self/evict-user`;
  return request(endpoint, 'DELETE', {
    'Content-Type': 'application/json',
  });
};

export const getUserRoles = () => request(`${env.aceApi}api/1/accounts/roles`);
